import type { RefinementList } from '@/domain/search/types'

export type TermType =
  | 'accepted_insurance'
  | 'activity'
  | 'amenities'
  | 'price'
  | 'setting'
  | 'treatment_method'
  | 'treatment_services'
  | 'treatment_therapy'
  | 'what_we_treat'
  | 'who_we_treat'
  | 'special_consideration'
  | 'special_considerations'
  | 'treatment_therapies'
  | 'activities'
  | 'treatment_methods'
  | 'language'
  | 'languages'

export enum FeedMode {
  NONE = 'NONE',
  PRIMARY_FOCUS_STRICT = 'PRIMARY_FOCUS_STRICT',
  PROVIDER_TYPE_STRICT = 'PROVIDER_TYPE_STRICT',
  LOCATION_STRICT = 'LOCATION_STRICT'
}

export type Term = {
  id: number
  title: string
  slug: string
  type: TermType
  global?: boolean
  indexType?: string
  feedMode?: FeedMode
}

export type PopularTreatmentItem = {
  label: string
  slug: string
  attribute: Pick<RefinementList, keyof RefinementList> | string
  position?: number
  blogImageSlug?: string
}
